<template>
  <div>
    <CRow class="mb-3 search-panel">
      <CCol xs="12" sm="6" md="4" lg="4" xl="2">
        <div class="form-group">
          <label for="datepicker">Từ ngày - đến ngày</label>
          <DatePicker locale="vi" id="datepicker" v-model="dateRange" :model-config="dateRangeConfig" :masks="{ input: 'DD/MM/YYYY', data : 'DD/MM/YYYY' }" is-range class="datepicker">
            <template v-slot="{ inputValue, inputEvents }">
              <input
                :value="inputValue.start + ' - ' + inputValue.end"
                v-on="inputEvents.start"
                class="border px-2 py-1 rounded focus:outline-none focus:border-indigo-300"
                readonly
              />
            </template>
          </DatePicker>
        </div>
      </CCol>
      <CCol xs="12" sm="6" md="4" lg="4" xl="2">
        <BaseSelect v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE')"
          :options="audioStationSelect.options"
          :data="audioStationSelect.data"
          ref="audioStationSelect"
        ></BaseSelect>
      </CCol>
      <CCol>
        <div class="form-group">
          <label style="color: white"></label>
          <div style="margin-top: 10px">
            <CButton
              style="float: right;margin-left: 5px;"
              color="primary"
              v-c-tooltip.hover="'Xuất báo cáo'"
              class="btn-action-primary"
              @click="exportSubmit()">
              <i class="fa fa-download"></i>&nbsp;&nbsp;Xuất báo cáo
            </CButton>
            <CButton
              style="float: right; margin-left: 5px"
              color="primary"
              v-c-tooltip.hover="'Tải lại'"
              class="btn-action-primary"
              @click="loadDataMainTable(true)"
            >
              <i class="fa fa-refresh"></i>&nbsp;&nbsp; Tải lại
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>

    <CRow>
      <CCol>
        <CCard>
          <CCardHeader color="light">
            <i class="fa fa-file"></i>
            <strong> Số lượng bản tin phát thanh </strong>
            <!--                    <small>kết nối </small>-->
            <strong>({{ statisticAudioBroadcast.total }})</strong>
          </CCardHeader>
          <CCardBody class="row text-center">
            <div class="col" style="color: #000000 !important">
              <div class="text-value-lg">
                {{ statisticAudioBroadcast.total }}
              </div>
              <div class="text-uppercase text-muted small">Tổng</div>
            </div>
            <div class="c-vr"></div>
            <div class="c-vr"></div>
            <div class="col" style="color: #1bbf1b !important">
              <div class="text-value-lg">
                {{ statisticAudioBroadcast.totalBroadcast || 0 }}
              </div>
              <div class="text-uppercase text-muted small">Đã phát</div>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable
          :options="mainTable.options"
          :slots="mainTable.slots"
          :dataSource="mainTable.dataSource"
          ref="mainTable"
        >
          <template #index="{ index }">
            <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
          </template>
          <template #createDate="{ item }">
            <td v-if="item.createDate != null">
              {{ $helper.formatDateDDMMYYYYHHMM(item.createDate) }}
            </td>
            <td v-if="item.createDate == null"></td>
          </template>
          <template #level="{ item }">
            <td>
              <span class="badge badge-success" v-if="item.level == 0"
              >Bình thường</span
              >
              <span class="badge badge-warning" v-if="item.level == 1"
              >Ưu tiên</span
              >
              <span class="badge badge-danger" v-if="item.level == 2"
              >Khẩn cấp</span
              >
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import {AudioHistoryType, LOCATION_CODE_NAME} from "../../constant";
import BaseTable from "../base/BaseDataTable";
import BaseInput from "../base/BaseInput";
import BaseSelect from "../base/BaseSelect2";
import {DatePicker} from "v-calendar";

export default {
  name: "ReportAudioFileBroadcast",
  components: {
    BaseTable,
    BaseInput,
    BaseSelect,
    DatePicker
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
    },
    showWarningMsg: {
      type: "warn",
      title: "warn",
    },
  },
  data() {
    let that = this;
    return {
      statisticAudioBroadcast: {},
      dateRange: {
        start: this.$helper.subtractNowDate(7).setHours(0, 0, 0, 0),
        end: new Date().setHours(23, 59, 59, 999)
      },
      dateRangeConfig: {
        start: {
          timeAdjust: '00:00:00',
        },
        end: {
          timeAdjust: '23:59:59',
        },
      },
      titleInput: {
        options: {
          placeholder: "Tiêu đề bản tin",
          label: "Tiêu đề bản tin",
        },
        data: {
          name: "fileName",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        },
      },
      audioStationSelect: {
        options: {
          filter: true,
          label: "Đài truyền thanh",
          'keyField': 'value',
          'valueField': 'text',
          selectAllText: "Tất cả đài truyền thanh",
          lazyLoad: (this.$hasAuthor('ROLE_ADMIN') || this.$hasAuthor('ROLE_PROVINCE')) ? false : true
        },
        data: {
          name: "stationId",
          model: "",
          source: {
            url: '/audio-station/list-audio-station-id-name',
            isJsonContentType: false,
            response: function (dataResponse) {
              return dataResponse.data;
            }
          },
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        },
      },
      historyType: {
        data: {
          name: "historyType",
          model: AudioHistoryType.DA_PHAT,
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        },
      },
      mainTable: {
        options: {
          fields: [
            {key: "index", label: "STT"},
            {key: "fileName", label: "Tiêu đề"},
            {key: "fileTypeName", label: "Lĩnh vực"},
            {key: "createDate", label: "Thời gian phát"},
            {key: "level", label: "Cấp độ"},
            {key: "deviceCode", label: "Mã thiết bị phát"},
            {key: "location", label: "Địa bàn"},
          ],
          slots: ["index", "level", "createDate"],
        },
        dataSource: {
          url: "/report/audio-file-broadcast",
          dataSubmit: function () {
            let params = that.$helper.setupDataSubmit(that.$data);
            params.fromDate = that.$helper.formatDate(that.dateRange.start)
            params.toDate = that.$helper.formatDate(that.dateRange.end)
            return params;
          },
          response: function (dataResponse) {
            that.statisticAudioBroadcast = dataResponse.data.statisticAudioBroadcast;
            return dataResponse.data.pageAudioBroadCast;
          },
        },
      },
    };
  },
  methods: {
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    exportSubmit() {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/exports/audio-files",
        dataSubmit: function () {
          return {
            fromDate : that.$helper.formatDate(that.dateRange.start),
            toDate : that.$helper.formatDate(that.dateRange.end),
            stationId: that.audioStationSelect.data.model
          };
        },
        isJsonContentType: false,
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
          } else {
            that.$helper.fetchAndDownloadByURI(response.data.data.path, response.data.data.name);
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    }
  },
  created: function () {
  },
  mounted() {},
  watch: {
    dateRange: function (newValue) {
      if (newValue) {
        this.loadDataMainTable();
      } else {
        this.dateRange = {
          start: this.$helper.subtractNowDate(7).setHours(0, 0, 0, 0),
          end: new Date().setHours(23, 59, 59, 999)
        }
      }
    }
  },
  computed: {},
};
</script>
<style scoped>
.td-roles {
  max-width: 250px;
}
</style>
